module.exports = __webpack_public_path__ + "img/standard_dx.217354f4.png";